import { withPanoViewerMethods, PanoViewer, PANOVIEWER_EVENTS, DEFAULT_CANVAS_CLASS, updatePanoViewer, PANOVIEWER_OPTIONS, withSpinViewerMethods, SpinViewer, SPINVIEWER_EVENTS, DEFAULT_WRAPPER_CLASS, DEFAULT_IMAGE_CLASS, SPINVIEWER_OPTIONS } from '@egjs/view360';
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

const _c0 = ["canvas"];
const _c1 = ["*"];
export * from '@egjs/view360';
import { EventEmitter, Component, ElementRef, Renderer2, Inject, PLATFORM_ID, Input, Output, ViewChild, NgModule } from '@angular/core';
import { isPlatformBrowser, CommonModule } from '@angular/common';
import { __decorate, __metadata } from 'tslib';

class PanoViewerInterface {
}
__decorate([
    withPanoViewerMethods,
    __metadata("design:type", PanoViewer)
], PanoViewerInterface.prototype, "_vanillaPanoViewer", void 0);

/**
 * Copyright (c) 2015 NAVER Corp.
 * egjs projects are licensed under the MIT license
 */
class NgxPanoViewerComponent extends PanoViewerInterface {
    constructor(_elRef, _renderer, _platformId) {
        super();
        this._elRef = _elRef;
        this._renderer = _renderer;
        this._platformId = _platformId;
        this._vanillaPanoViewer = null;
        Object.keys(PANOVIEWER_EVENTS).forEach(evtKey => {
            const evtName = PANOVIEWER_EVENTS[evtKey];
            this[evtName] = new EventEmitter();
        });
    }
    get element() { return this._elRef.nativeElement; }
    get _canvasElClass() { var _a; return (_a = this.canvasClass) !== null && _a !== void 0 ? _a : DEFAULT_CANVAS_CLASS; }
    ngAfterViewInit() {
        if (!isPlatformBrowser(this._platformId))
            return;
        const container = this._elRef.nativeElement;
        const props = this._getProps();
        this._vanillaPanoViewer = new PanoViewer(container, props);
        this._bindEvents();
        this._prevProps = Object.assign({}, props);
    }
    ngOnDestroy() {
        var _a;
        (_a = this._vanillaPanoViewer) === null || _a === void 0 ? void 0 : _a.destroy();
    }
    ngOnChanges(changes) {
        if (!this._vanillaPanoViewer)
            return;
        const props = this._getProps();
        const prevProps = this._prevProps;
        const [changedProps, changedPrevProps] = Object.keys(changes).reduce(([propsCollected, prevPropsCollected], propName) => {
            propsCollected[propName] = changes[propName].currentValue;
            prevPropsCollected[propName] = changes[propName].previousValue;
            return [propsCollected, prevPropsCollected];
        }, [{}, {}]);
        // Image is changed, change canvas element to prevent context lost
        if (changes.image.currentValue != null || changes.video.currentValue != null) {
            const renderer = this._renderer;
            const container = this._elRef.nativeElement;
            const originalCanvas = this.canvas.nativeElement;
            const clonedCanvas = originalCanvas.cloneNode(true);
            renderer.insertBefore(container, clonedCanvas, originalCanvas);
            renderer.removeChild(container, originalCanvas);
            this.canvas.nativeElement = clonedCanvas;
        }
        updatePanoViewer(this._vanillaPanoViewer, Object.assign(Object.assign({}, props), changedProps), Object.assign(Object.assign({}, prevProps), changedPrevProps));
        this._prevProps = props;
    }
    _bindEvents() {
        const panoViewer = this._vanillaPanoViewer;
        Object.keys(PANOVIEWER_EVENTS).forEach(evtKey => {
            const evtName = PANOVIEWER_EVENTS[evtKey];
            panoViewer.on(evtName, e => {
                const emitter = this[evtName];
                e.currentTarget = this;
                if (emitter) {
                    emitter.emit(e);
                }
            });
        });
    }
    _getProps() {
        return Object.keys(PANOVIEWER_OPTIONS).reduce((collected, key) => {
            if (this[key] !== undefined) {
                collected[key] = this[key];
            }
            return collected;
        }, {});
    }
}
NgxPanoViewerComponent.ɵfac = function NgxPanoViewerComponent_Factory(t) { return new (t || NgxPanoViewerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(PLATFORM_ID)); };
NgxPanoViewerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxPanoViewerComponent, selectors: [["ngx-pano-viewer"], ["", "NgxPanoViewer", ""]], viewQuery: function NgxPanoViewerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.canvas = _t.first);
    } }, hostAttrs: [2, "display", "block"], inputs: { image: "image", video: "video", projectionType: "projectionType", cubemapConfig: "cubemapConfig", stereoFormat: "stereoFormat", width: "width", height: "height", yaw: "yaw", pitch: "pitch", fov: "fov", showPolePoint: "showPolePoint", useZoom: "useZoom", useKeyboard: "useKeyboard", gyroMode: "gyroMode", yawRange: "yawRange", pitchRange: "pitchRange", fovRange: "fovRange", touchDirection: "touchDirection", canvasClass: "canvasClass" }, outputs: { ready: "ready", viewChange: "viewChange", animationEnd: "animationEnd", error: "error" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c1, decls: 3, vars: 1, consts: [[3, "ngClass"], ["canvas", ""]], template: function NgxPanoViewerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelement(0, "canvas", 0, 1);
        ɵngcc0.ɵɵprojection(2);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx._canvasElClass);
    } }, directives: [ɵngcc1.NgClass], encapsulation: 2 });
NgxPanoViewerComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
];
NgxPanoViewerComponent.propDecorators = {
    image: [{ type: Input }],
    video: [{ type: Input }],
    projectionType: [{ type: Input }],
    cubemapConfig: [{ type: Input }],
    stereoFormat: [{ type: Input }],
    width: [{ type: Input }],
    height: [{ type: Input }],
    yaw: [{ type: Input }],
    pitch: [{ type: Input }],
    fov: [{ type: Input }],
    showPolePoint: [{ type: Input }],
    useZoom: [{ type: Input }],
    useKeyboard: [{ type: Input }],
    gyroMode: [{ type: Input }],
    yawRange: [{ type: Input }],
    pitchRange: [{ type: Input }],
    fovRange: [{ type: Input }],
    touchDirection: [{ type: Input }],
    canvasClass: [{ type: Input }],
    ready: [{ type: Output }],
    viewChange: [{ type: Output }],
    animationEnd: [{ type: Output }],
    error: [{ type: Output }],
    canvas: [{ type: ViewChild, args: ["canvas",] }]
};

class NgxPanoViewerModule {
}
NgxPanoViewerModule.ɵfac = function NgxPanoViewerModule_Factory(t) { return new (t || NgxPanoViewerModule)(); };
NgxPanoViewerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxPanoViewerModule });
NgxPanoViewerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule
        ]] });

class SpinViewerInterface {
}
__decorate([
    withSpinViewerMethods,
    __metadata("design:type", SpinViewer)
], SpinViewerInterface.prototype, "_vanillaSpinViewer", void 0);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxPanoViewerComponent, [{
        type: Component,
        args: [{
                selector: "ngx-pano-viewer, [NgxPanoViewer]",
                template: `
    <canvas #canvas [ngClass]="_canvasElClass"></canvas>
    <ng-content></ng-content>
  `,
                host: {
                    style: "display: block;"
                }
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: undefined, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }]; }, { image: [{
            type: Input
        }], video: [{
            type: Input
        }], projectionType: [{
            type: Input
        }], cubemapConfig: [{
            type: Input
        }], stereoFormat: [{
            type: Input
        }], width: [{
            type: Input
        }], height: [{
            type: Input
        }], yaw: [{
            type: Input
        }], pitch: [{
            type: Input
        }], fov: [{
            type: Input
        }], showPolePoint: [{
            type: Input
        }], useZoom: [{
            type: Input
        }], useKeyboard: [{
            type: Input
        }], gyroMode: [{
            type: Input
        }], yawRange: [{
            type: Input
        }], pitchRange: [{
            type: Input
        }], fovRange: [{
            type: Input
        }], touchDirection: [{
            type: Input
        }], canvasClass: [{
            type: Input
        }], ready: [{
            type: Output
        }], viewChange: [{
            type: Output
        }], animationEnd: [{
            type: Output
        }], error: [{
            type: Output
        }], canvas: [{
            type: ViewChild,
            args: ["canvas"]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxPanoViewerModule, [{
        type: NgModule,
        args: [{
                declarations: [NgxPanoViewerComponent],
                imports: [
                    CommonModule
                ],
                exports: [NgxPanoViewerComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxPanoViewerModule, { declarations: function () { return [NgxPanoViewerComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [NgxPanoViewerComponent]; } }); })();

/**
 * Copyright (c) 2015 NAVER Corp.
 * egjs projects are licensed under the MIT license
 */
class NgxSpinViewerComponent extends SpinViewerInterface {
    constructor(_elRef, _platformId) {
        super();
        this._elRef = _elRef;
        this._platformId = _platformId;
        this._vanillaSpinViewer = null;
        Object.keys(SPINVIEWER_EVENTS).forEach(evtKey => {
            const evtName = SPINVIEWER_EVENTS[evtKey];
            this[evtName] = new EventEmitter();
        });
    }
    get element() { return this._elRef.nativeElement; }
    get _wrapperElClass() { var _a; return (_a = this.wrapperClass) !== null && _a !== void 0 ? _a : DEFAULT_WRAPPER_CLASS; }
    get _imageClass() { var _a; return (_a = this.imageClass) !== null && _a !== void 0 ? _a : DEFAULT_IMAGE_CLASS; }
    ngAfterViewInit() {
        if (!isPlatformBrowser(this._platformId))
            return;
        const container = this._elRef.nativeElement;
        const props = this._getProps();
        this._vanillaSpinViewer = new SpinViewer(container, props);
        this._bindEvents();
    }
    ngOnChanges(changes) {
        if (!this._vanillaSpinViewer)
            return;
        if (changes.scale.currentValue != null) {
            this._vanillaSpinViewer.setScale(changes.scale.currentValue);
        }
    }
    _bindEvents() {
        const spinViewer = this._vanillaSpinViewer;
        Object.keys(SPINVIEWER_EVENTS).forEach(evtKey => {
            const evtName = SPINVIEWER_EVENTS[evtKey];
            spinViewer.on(evtName, e => {
                const emitter = this[evtName];
                e.currentTarget = this;
                if (emitter) {
                    emitter.emit(e);
                }
            });
        });
    }
    _getProps() {
        return Object.keys(SPINVIEWER_OPTIONS).reduce((collected, key) => {
            if (this[key] !== undefined) {
                collected[key] = this[key];
            }
            return collected;
        }, {});
    }
}
NgxSpinViewerComponent.ɵfac = function NgxSpinViewerComponent_Factory(t) { return new (t || NgxSpinViewerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(PLATFORM_ID)); };
NgxSpinViewerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxSpinViewerComponent, selectors: [["ngx-spin-viewer"], ["", "NgxSpinViewer", ""]], hostAttrs: [2, "display", "block"], inputs: { imageUrl: "imageUrl", rowCount: "rowCount", colCount: "colCount", width: "width", height: "height", autoHeight: "autoHeight", colRow: "colRow", scale: "scale", frameIndex: "frameIndex", wrapperClass: "wrapperClass", imageClass: "imageClass" }, outputs: { load: "load", imageError: "imageError", change: "change", animationEnd: "animationEnd" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c1, decls: 3, vars: 2, consts: [[3, "ngClass"]], template: function NgxSpinViewerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "img", 0);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(2);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx._wrapperElClass);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx._imageElClass);
    } }, directives: [ɵngcc1.NgClass], encapsulation: 2 });
NgxSpinViewerComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
];
NgxSpinViewerComponent.propDecorators = {
    imageUrl: [{ type: Input }],
    rowCount: [{ type: Input }],
    colCount: [{ type: Input }],
    width: [{ type: Input }],
    height: [{ type: Input }],
    autoHeight: [{ type: Input }],
    colRow: [{ type: Input }],
    scale: [{ type: Input }],
    frameIndex: [{ type: Input }],
    wrapperClass: [{ type: Input }],
    imageClass: [{ type: Input }],
    load: [{ type: Output }],
    imageError: [{ type: Output }],
    change: [{ type: Output }],
    animationEnd: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxSpinViewerComponent, [{
        type: Component,
        args: [{
                selector: "ngx-spin-viewer, [NgxSpinViewer]",
                template: `
    <div [ngClass]="_wrapperElClass">
      <img [ngClass]="_imageElClass" />
    </div>
    <ng-content></ng-content>
  `,
                host: {
                    style: "display: block;"
                }
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }]; }, { imageUrl: [{
            type: Input
        }], rowCount: [{
            type: Input
        }], colCount: [{
            type: Input
        }], width: [{
            type: Input
        }], height: [{
            type: Input
        }], autoHeight: [{
            type: Input
        }], colRow: [{
            type: Input
        }], scale: [{
            type: Input
        }], frameIndex: [{
            type: Input
        }], wrapperClass: [{
            type: Input
        }], imageClass: [{
            type: Input
        }], load: [{
            type: Output
        }], imageError: [{
            type: Output
        }], change: [{
            type: Output
        }], animationEnd: [{
            type: Output
        }] }); })();

class NgxSpinViewerModule {
}
NgxSpinViewerModule.ɵfac = function NgxSpinViewerModule_Factory(t) { return new (t || NgxSpinViewerModule)(); };
NgxSpinViewerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxSpinViewerModule });
NgxSpinViewerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxSpinViewerModule, [{
        type: NgModule,
        args: [{
                declarations: [NgxSpinViewerComponent],
                imports: [
                    CommonModule
                ],
                exports: [NgxSpinViewerComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxSpinViewerModule, { declarations: function () { return [NgxSpinViewerComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [NgxSpinViewerComponent]; } }); })();

/*
 * Public API Surface of ngx-view360
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxPanoViewerComponent, NgxPanoViewerModule, NgxSpinViewerComponent, NgxSpinViewerModule };

//# sourceMappingURL=egjs-ngx-view360.js.map